import { render, staticRenderFns } from "./BrandPieChart.vue?vue&type=template&id=0c483b9d&"
import script from "./BrandPieChart.vue?vue&type=script&lang=js&"
export * from "./BrandPieChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports